import { useState } from "react";
import "./Services.css";

import haushalt from "../assets/haushalt.jpg";
import entr from "../assets/entruempelung.jpg";
import garten from "../assets/gartenpflege.jpg";
import hausm from "../assets/hausmeister.jpg";
import geb from "../assets/gebaeudebetreuung.jpg";
import rein from "../assets/reinigung.jpg";

import ServiceModal from "./ServiceModal";

export default function Services() {
  const [activeService, setActiveService] = useState(null);

  const services = [
    { title: "Haushaltsauflösungen", img: haushalt, folder: "haushalt" },
    { title: "Entrümpelungen", img: entr, folder: "entruempelung" },
    { title: "Garten- und Grabpflege", img: garten, folder: "gartenpflege" },
    { title: "Hausmeisterservice", img: hausm, folder: "hausmeister" },
    { title: "Wohnungs- und Gebäudebetreuung", img: geb, folder: "gebaeudebetreuung" },
    { title: "Gebäudereinigung", img: rein, folder: "reinigung" }
  ];

  return (
    <>
      <section id="services" className="services-section">
        <div className="services-container">
          <h2>Dienstleistungen</h2>
          <div className="services-grid">
            {services.map((s, i) => (
              <div
                key={i}
                className="service-card"
                style={{ backgroundImage: `url(${s.img})` }}
                onClick={() => setActiveService(s)}
              >
                <div className="card-overlay">
                  <h3>{s.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {activeService && (
        <ServiceModal
          service={activeService}
          onClose={() => setActiveService(null)}
        />
      )}
    </>
  );
}